import { usePermissions } from '../redux/PermissionsContext';

const usePermissionCheck = (requiredPermissions) => {
    const { hasPermission } = usePermissions();
    return hasPermission(requiredPermissions);
};

export default usePermissionCheck;
